import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWeb = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M13.8 7H10.2C9.0799 7 8.51984 7 8.09202 7.21799C7.71569 7.40973 7.40973 7.71569 7.21799 8.09202C7 8.51984 7 9.0799 7 10.2V11.8C7 12.9201 7 13.4802 7.21799 13.908C7.40973 14.2843 7.71569 14.5903 8.09202 14.782C8.51984 15 9.0799 15 10.2 15H13.8C14.9201 15 15.4802 15 15.908 14.782C16.2843 14.5903 16.5903 14.2843 16.782 13.908C17 13.4802 17 12.9201 17 11.8V10.2C17 9.0799 17 8.51984 16.782 8.09202C16.5903 7.71569 16.2843 7.40973 15.908 7.21799C15.4802 7 14.9201 7 13.8 7Z",
		stroke: "currentColor",
		strokeWidth: 2
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9 19H12H15",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgWeb;
